export default {
  id: 'completed-Guest',
  navTitleID: 'completed-Guest.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    }
  ]
}
